<template>
    <div id="app" :class="{ mybeauty: isMyBeauty }">
        <SiteHeader />
        <div class="router-view">
            <router-view></router-view>
        </div>
        <SiteFooter />
    </div>
</template>

<script setup>
    import { ref, computed, watch, inject } from 'vue'
    import { useRoute } from 'vue-router'
    import SiteHeader from './components/Header.vue'
    import SiteFooter from './components/Footer.vue'

    const injectedIsMyBeauty = inject('isMyBeauty', undefined)
    const route = useRoute()
    const routeIsMyBeauty = computed(() =>
        route.params.isMyBeauty === 'mybeauty' ||
        route.query.isMyBeauty === 'true' ||
        route.query.isMyBeauty === true
    )

    // Use injected value if available, otherwise fallback to route
    const isMyBeauty = computed(() =>
        injectedIsMyBeauty !== undefined ? injectedIsMyBeauty : routeIsMyBeauty.value
    )

    const dynamicTitle = computed(() =>
        isMyBeauty.value ? 'MyBeauty - Harrods' : 'Harrods Digital Rewards'
    )

    watch(dynamicTitle, (newTitle) => {
        document.title = newTitle
    }, { immediate: true })
</script>

<style lang="scss">
@import '@/scss/base.scss';

  .router-view {
      padding-top: 75px;
  }
</style>
